module.exports = __webpack_public_path__ + "img/calendar.407044d4.svg";